import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/InputSheet.css";
import { MdOpenInNew } from "react-icons/md";
import SingleScanOffcanvas from "../../helper/SingleScanOffcanvas";
import { FaSearch } from "react-icons/fa";
import { singleScanRequest } from "../../redux/actions/scanActions";

const Scan = () => {
  const dispatch = useDispatch();
  const { loading, scans, error } = useSelector(
    (state) =>
      state.singleScan || {
        loading: false,
        scans: [],
        error: null,
      }
  );
  const [search, setSearch] = useState("");
  const [selectedScan, setSelectedScan] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("user") || "{}");
    const oemId = userData.itSalesPartner?.id;
    if (oemId) {
      dispatch(singleScanRequest(oemId, search));
    }
  }, [dispatch, search]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleViewDetails = (scan) => {
    setSelectedScan(scan);
    setShowOffcanvas(true);
  };

  const handleDownloadReport = (domainLink) => {
    window.open(domainLink, '_blank');
  };

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div
          className="mt-2 d-flex align-items-end justify-content-between"
          style={{ padding: "0 20px" }}
        >
          <div>
            <p style={{ color: "black", margin: "5px 0 0 0" }}>
              Total Scans: {scans?.length || 0}
            </p>
          </div>
          {/* Search Bar */}
          <div className="position-relative d-flex justify-content-end">
            <input
              type="search"
              placeholder="Search scans...."
              className="form-input"
              value={search}
              onChange={handleSearch}
              style={{ width: "220px" }}
            />
            {search === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  transform: "translateY(-50%)",
                  color: "#666",
                }}
              >
                <FaSearch />
              </div>
            )}
          </div>
        </div>
        <div className="input-form-section">
          <div className="table-scroll-wrapper">
            <table className="partners-table">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Date/Time</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Domain</th>
                  <th>Report Scan</th>
                  <th>Language</th>
                  <th>Scan Url</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="12"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#666",
                      }}
                    >
                      <div className="loading-spinner">
                      </div>
                    </td>
                  </tr>
                ) : scans?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="12"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#666",
                      }}
                    >
                      No scan-list found
                    </td>
                  </tr>
                ) : (
                  scans.map((scan, index) => (
                    <tr key={scan._id}>
                      <td>{index + 1}</td>
                      <td>
                        {new Date(scan.createdAt).toLocaleDateString()}
                        <br />
                        <small>
                          {new Date(scan.createdAt).toLocaleTimeString()}
                        </small>
                      </td>
                      <td>
                        {scan.user?.firstName
                          ? scan.user.firstName.charAt(0).toUpperCase() +
                            scan.user.firstName.slice(1)
                          : ""}{" "}
                        {scan.user?.lastName
                          ? scan.user.lastName.charAt(0).toUpperCase() +
                            scan.user.lastName.slice(1)
                          : ""}
                      </td>

                      <td>{scan.user?.email}</td>
                      <td>{scan.domain}</td>
                         <td>
                          <span
                            className={`status-badge ${
                              scan.pdfUrl ? "sent" : "pending"
                            }`}
                          >
                            {scan.pdfUrl ? "Sent" : "Pending"}
                          </span>
                        </td>
                        <td>
                          {scan.language ==='eng' ? 'English' : scan.language === 'ja' ? 'Japanese' : scan.language || 'N/A'
                          }
                        </td>
                      <td>
                        {scan.pdfUrl ? (
                          <MdOpenInNew 
                            onClick={() => handleDownloadReport(scan.pdfUrl)}
                            className="info_pointer fs-5"
                            title="Download Report"
                            style={{ color: '#737EE2', cursor: 'pointer' }}
                          />
                        ) : (
                          <span style={{ color: '#666' }}>N/A</span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <SingleScanOffcanvas
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          scanData={selectedScan}
        />
      </div>
    </div>
  );
};

export default Scan;
